import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";


export const fetchScreenComponents = createAsyncThunk(
    'components/fetchScreenComponents',
    async (activeScreenSlug) => {

        return axios({
            method: 'get',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/page`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            params: {page_slug: activeScreenSlug, member_id: appLocalizer.userId},
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
);
export const saveComponent = createAsyncThunk(
    'components/saveComponent',
    async (component) => {

        return axios({
            method: 'put',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/page/component`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            data: component,
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
);
export const addComponent = createAsyncThunk(
    'components/addComponent',
    async (component) => {
        return axios({
            method: 'post',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/page/component`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            data: component,
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
);

export const removeComponent = createAsyncThunk(
    'components/removeComponent',
    async (id) => {
        return axios({
            method: 'delete',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/page/component`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            data: {id},
        }).then((response) => {
            response.data.id = id; // Ensure the response contains the ID of the removed component
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })

    }
);
export const reorderComponents = createAsyncThunk(
    'components/reorderComponents',
    async (components) => {
        return axios({
            method: 'put',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/page/sort-components`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            data: components,
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })

    }
);